var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgContractDisclosure(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m368.466 126.4h-96.4c-8.284 0-15-6.716-15-15v-96.4c0-6.067 3.654-11.537 9.26-13.858 5.604-2.319 12.058-1.039 16.347 3.252l96.4 96.4c4.29 4.29 5.573 10.742 3.252 16.347-2.322 5.604-7.791 9.259-13.859 9.259z",
    fill: "#a4d3f4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m368.467 96.4h-66.4c-8.284 0-15-6.716-15-15v-66.4c0-8.284-6.716-15-15-15h-257.067c-8.284 0-15 6.716-15 15v482c0 8.284 6.716 15 15 15h353.467c8.284 0 15-6.716 15-15v-385.6c0-8.284-6.716-15-15-15z",
    fill: "#edf5ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m383.467 497v-385.6c0-8.284-6.716-15-15-15h-66.4c-8.284 0-15-6.716-15-15v-66.4c0-8.284-6.716-15-15-15h-80.333v512h176.733c8.284 0 15-6.716 15-15z",
    fill: "#c8e3fe"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#185e6e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m304.2 254.933h-224.933c-8.284 0-15-6.716-15-15s6.716-15 15-15h224.933c8.284 0 15 6.716 15 15s-6.716 15-15 15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m143.533 190.667h-64.266c-8.284 0-15-6.716-15-15s6.716-15 15-15h64.267c8.284 0 15 6.716 15 15s-6.717 15-15.001 15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m239.933 319.2h-160.666c-8.284 0-15-6.716-15-15s6.716-15 15-15h160.667c8.284 0 15 6.716 15 15s-6.717 15-15.001 15z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m299.224 391.292c-5.628-6.079-15.118-6.443-21.196-.814-7.234 6.381-23.91 11.724-39.159 11.17-.031-5.938.187-13.339-4.529-20.415-5.176-7.764-14.105-11.7-26.539-11.7-21.654 0-40.646 18.366-42.74 20.46-5.858 5.858-5.858 15.355 0 21.213 5.857 5.858 15.355 5.858 21.213 0 3.008-3.007 13.873-11.985 22.591-11.654.031 5.938-.187 13.339 4.53 20.414 5.176 7.764 14.105 11.7 26.539 11.7 37.009 0 56.387-17.214 58.475-19.177 6.078-5.628 6.443-15.119.815-21.197z",
    fill: "#11d9ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m278.027 390.478c-7.234 6.381-23.91 11.724-39.159 11.17-.031-5.938.187-13.339-4.529-20.415-5.176-7.764-14.105-11.7-26.539-11.7-5.619 0-11.055 1.242-16.066 3.111v33.988c4.745-3.489 11.396-7.297 17.131-7.08.031 5.938-.187 13.339 4.53 20.414 5.176 7.764 14.105 11.7 26.539 11.7 37.009 0 56.387-17.214 58.475-19.177 6.079-5.628 6.444-15.119.815-21.198-5.629-6.078-15.118-6.442-21.197-.813z",
    fill: "#21affa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m288.134 415.6c-8.284 0-15-6.716-15-15 0-33.302 12.971-64.617 36.524-88.179l131.263-131.29c2.813-2.815 6.63-4.397 10.61-4.397 15.92 0 31.5 6.454 42.743 17.706 11.265 11.269 17.726 26.844 17.726 42.73 0 3.979-1.581 7.802-4.395 10.615-.001 0-131.259 131.285-131.259 131.285-23.205 23.216-55.357 36.53-88.212 36.53z",
    fill: "#3083e8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m304.2 224.933h-112.467v30h112.467c8.284 0 15-6.716 15-15s-6.716-15-15-15z",
    fill: "#0b3c49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m191.733 319.2h48.2c8.284 0 15-6.716 15-15s-6.716-15-15-15h-48.2z",
    fill: "#0b3c49"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContractDisclosure);
export default __webpack_public_path__ + "static/media/contract-disclosure.a841984fa1f40148249f113dd1970359.svg";
export { ForwardRef as ReactComponent };